<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Delete Invoices Import"
    @on-hide="resetFormData"
  >
    <imports-form
      destructive-subtitle="This will delete the selected invoices."

      @on-submit="createImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Delete Invoices Template.xlsx"
              :file-provider="$importsAPI.getDeleteInvoicesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'DeleteInvoicesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'delete-invoices-imports-add-modal',
    };
  },
  methods: {
    createImport(data, handleCreate) {
      handleCreate(this.$importsAPI.deleteInvoicesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
